import React from "react";

import attachmentApi, { AttachmentApi } from "../../api/attachment";

const AttachmentContext = React.createContext<AttachmentApi>(attachmentApi);

export default AttachmentContext;
